import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccount } from '@ibk/shared-auth';
import { ENV_VARS } from '@ibk/shared-config';
import { useTranslation } from '@ibk/shared-translation';
import { AccountRelationshipType } from '@ibk/shared-types';
import { transferSession } from './bpoDomains';
import styles from './BpoReturnButton.module.css';
import { isSessionFromBpo } from './bpoSession';
import { bpoTranslations } from './translations';
export default function BpoReturnButton({ collapsed }) {
    const { getAccounts } = useAccount();
    const navigate = useNavigate();
    const { currentLanguage } = useTranslation();
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(false);
    const opening = useRef(false);
    const text = bpoTranslations[currentLanguage];
    if (!isSessionFromBpo() ||
        !getAccounts().some(account => [AccountRelationshipType.OPERATOR, AccountRelationshipType.OWNER, AccountRelationshipType.HOLDER].includes(account.accountRelationshipType)))
        return null;
    const open = async () => {
        if (opening.current)
            return;
        opening.current = true;
        setBusy(true);
        setError(false);
        try {
            if (ENV_VARS.VITE_DOMINIO_BPO_URL)
                await transferSession('bpo');
            else
                navigate('/bpo/clientes');
        }
        catch {
            setError(true);
        }
        finally {
            opening.current = false;
            setBusy(false);
        }
    };
    return (_jsxs("div", { className: styles.container, children: [_jsxs("button", { type: 'button', className: styles.button, title: text['bpo.return'], "aria-label": text['bpo.return'], "aria-busy": busy, disabled: busy, onClick: open, children: [_jsx("svg", { width: '16', height: '16', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: '2', strokeLinecap: 'round', strokeLinejoin: 'round', "aria-hidden": 'true', children: _jsx("path", { d: 'm11 17-5-5 5-5 M18 17l-5-5 5-5' }) }), !collapsed && _jsx("span", { children: text['bpo.return'] })] }), error && (_jsx("span", { role: 'alert', className: styles.error, children: text['bpo.operationError'] }))] }));
}
